module.exports = {
  "dof-panel": {
    "width": "686",
    "borderRadius": "16",
    "backgroundColor": "#ffffff"
  },
  "dof-panel-container": {
    "paddingTop": "40",
    "paddingRight": "32",
    "paddingBottom": "40",
    "paddingLeft": "32"
  },
  "dashboard": {
    "flexDirection": "row"
  },
  "cell": {
    "flex": 1,
    "justifyContent": "center",
    "alignItems": "stretch",
    "borderColor": "#f2f2f2"
  },
  "title": {
    "alignItems": "center",
    "justifyContent": "center"
  },
  "title-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "24",
    "lineHeight": "24",
    "color": "#616C73",
    "lines": 1,
    "textOverflow": "ellipsis"
  },
  "value": {
    "flexDirection": "row",
    "marginTop": "18",
    "alignItems": "flex-end",
    "justifyContent": "center"
  },
  "value-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "44",
    "lineHeight": "44",
    "color": "#1E2E37"
  },
  "unit-text": {
    "marginLeft": "6",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "24",
    "lineHeight": "32",
    "color": "#616C73"
  },
  "btn": {
    "height": "100",
    "alignItems": "center",
    "justifyContent": "center",
    "borderTopWidth": "1",
    "borderColor": "#f2f2f2"
  },
  "btn-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "28",
    "color": "#00A4F2",
    "textAlign": "center",
    "lineHeight": "28"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-5def8261!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-panel/index.vue
// module id = 490
// module chunks = 0 1